/* eslint-disable react-hooks/exhaustive-deps */
import React, { createRef, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import NumberFormat from "react-number-format";
import { Button, Input, Select, DatePicker, Modal, Icon, SelectActions } from "../../components";
import { Constants, Globals, axios } from "../../utils";
import AddIcon from '../../assets/icons/add.png';
import TrashIcon from '../../assets/icons/trash.png';
import CreateEditClient from '../clients/create_edit_client';

const INITIAL_STATE = {
  client_id: '',
  comments: '',
  expiration_date: '',
  products: [],
  show_taxes: Constants.QUOTES.SHOW_TAXES.NO,
  subtotal: 0,
  iva: 0,
  iva_bs: 0,
  total: 0,
  discount: 0,
  discount_percentage: '',
  search: '',
  credit_days: null,
  status_payment: Constants.PAYMENT_TYPES.PAID,
  general_discounts: [],
}

class CreateEditQuote extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        ...INITIAL_STATE,
        seller_id: props.user.id,
      },
      client: null,
      modalProducts: false,
      disabled_button: false,
      visible_client: false,
      created_client: null,
      errors: [],
      products: [],
      data: {
        products: [],
        clients: [],
        zones: [],
        sellers: [],
        client_categories: [],
      },
      edit: false,
      textButton: "Crear",
      exchangeRate: 0,
      countryEquivalent: Globals.getUserCountryEquivalent(),
      config: null, // Configuración para decimales y stock negativo
      decimals: 2,
      discountsRules: [],
      general_discounts: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  abortController = new AbortController();
  debounce = createRef();

  componentDidMount = async () => {
    // CORRECCIÓN: Esperamos a que la config cargue y el estado se actualice ANTES de seguir
    await this.getConfig();

    this.getExchangeRate();
    this.getSellers();
    this.getZones();
    this.getClientCategories();
    await this.getClients();
    await this.getNewDiscounts();
    await this.getAdminGeneralDiscounts();

    // Ahora edit() se ejecutará sabiendo ya la configuración de decimales correcta
    if (this.props.edit) this.edit();
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  // CORRECCIÓN: Convertido a async y envuelto en Promise para asegurar setState
  getConfig = async () => {
    try {
      const { data } = await axios.post("sync/config", { user_id: this.props.user.id });
      // Usamos new Promise para asegurar que el setState termine antes de resolver
      await new Promise(resolve => this.setState({ config: data.config }, resolve));
    } catch (error) {
      Globals.showError();
    }
  };

  // Helper para decimales dinámicos
  getDecimals = () => {
    const { config } = this.state;
    // Soporte robusto para booleanos o strings "1"/"0"
    return (config?.three_decimals === Constants.STATUS_ACTIVE || config?.three_decimals === true || config?.three_decimals === "1") ? 3 : 2;
  }

  // Parseo dinámico según configuración
  parse = (value) => {
    return parseFloat(parseFloat(value || 0).toFixed(this.getDecimals()));
  }

  getClients = async (page = 1) => {
    axios
      .post("web/admin/quotes/clients", {
        page,
        web: true,
        admin_id: this.props.user.admin_id || this.props.user.id,
        search: this.state.form.search,
      })
      .then(async (res) => {
        if (res.data.clients) {
          let clients = res.data.clients.data;

          if (this.state.created_client) {
            // Omitir el cliente creado
            clients = clients.filter(i => i.id != this.state.created_client?.id);
            // Agrega el cliente recien creado de primero
            clients.unshift(this.state.created_client);
          }

          await this.setState(state => ({
            data: { ...state.data, clients }
          }));
        }
      })
      .catch(err => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  };

  getZones = async () => {
    axios
      .post("web/admin/zones", { user_id: this.props.user.id })
      .then(async ({ data }) => {
        data.zones.unshift({ id: "", name: "Todos" });
        await this.setState(state => ({
          data: {
            ...state.data,
            zones: data.zones.filter(item => item.id),
          }
        }));
      })
      .catch(() => Globals.showError());
  }

  getAdminGeneralDiscounts = async () => {
    await axios
      .post("admin/profile/generaldiscounts/get", { user_id: this.props.user.id, last_three: true })
      .then(({ data }) => {
        const initialDiscounts = data.discounts.map(d => ({
          discount_id: d.id,
          value: ''
        }));

        this.setState({
          general_discounts: data.discounts,
          form: {
            ...this.state.form,
            general_discounts: initialDiscounts
          }
        });
      })
      .catch(() => Globals.showError())
      .then(() => Globals.quitLoading());
  }

  getNewDiscounts = async () => {
    Globals.setLoading();

    try {
      const response = await axios.post('admin/discounts/get', { user_id: this.props.user.id, all: true, status: Constants.STATUS_ACTIVE });

      if (response.data && response.data.discounts) {
        this.setState({ discountsRules: response.data.discounts }, () => {
          Globals.quitLoading();
        });
      } else {
        // Si no hay descuentos, avanzamos directamente
        Globals.quitLoading();
      }
    } catch (error) {
      console.error("Error al obtener los descuentos", error);
      Globals.quitLoading();
    }
  }

  changeGeneralDiscount = async (discountId, value) => {
    await this.setState(state => {
      const general_discounts = [...state.form.general_discounts];
      const index = general_discounts.findIndex(d => d.discount_id === discountId);

      if (index >= 0) {
        general_discounts[index] = { ...general_discounts[index], value };
      } else {
        general_discounts.push({ discount_id: discountId, value });
      }

      return {
        form: {
          ...state.form,
          general_discounts
        }
      };
    });

    this.setTotals();
  }

  getSellers = async () => {
    Globals.setLoading();

    try {
      const filter = {
        user_id: this.props.user.id,
      };

      const res = await axios.post('web/admin/orders/sellers', filter);
      if (!res.data?.sellers) throw Error('No se encontraron los vendedores');

      const sellers = res.data.sellers.data.map(c => ({
        ...c,
        value: c.id,
        label: !!c.document ? `${c.name} - Rif ${c.document}` : c.name,
      }));

      await this.setState(state => ({
        data: { ...state.data, sellers }
      }));

    } catch (error) {
      Globals.showError(error?.message);
      console.log('NewRequest -> getSellers -> catch:', error)
    }

    Globals.quitLoading();
  }

  getClientCategories = async () => {
    await axios
      .post("admin/clients/categories", { user_id: this.props.user.id, is_select: true })
      .then(({ data }) => {
        data.categories.unshift({ id: "x", name: "Sin Categoría" });
        data.categories.unshift({ id: "", name: "Todas" });

        this.setState(state => ({
          data: {
            ...state.data,
            client_categories: data.categories,
          }
        }));
      })
      .catch(() => Globals.showError())
      .then(() => Globals.quitLoading());
  };

  getExchangeRate = async () => {
    try {
      const filter = { user_id: this.props.user.id };

      const res = await axios.post('admin/conversions', filter);
      if (!res.data?.conversion) throw Error('Debe establecer una tasa de cambio para continuar');

      this.setState({ exchangeRate: res.data?.conversion?.amount || 0 });

    } catch (error) {
      Globals.showError(error?.message);
      console.log('NewRequest -> getExchangeRate -> catch:', error)
    }
  };

  edit = async () => {
    let documents = {};
    const { element } = this.props.edit;
    console.log(element)

    let products_element = []
    element.details.map((item, index) => {
      let product = []
      if (item.product) {
        product = item.product;
        product.quantity = item.quantity;

        // El descuento manual es el registro en discounts con discount_id nulo
        let manualDisc = 0;
        if (item.discounts && item.discounts.length > 0) {
          const manualObj = item.discounts.find(d => d.discount_id === null);
          if (manualObj) manualDisc = parseFloat(manualObj.porcentage);
        } else if (!isNaN(Number(item.discount_percentage)) && String(item.discount_percentage).trim() !== '') {
          manualDisc = Number(item.discount_percentage);
        }

        product.manual_discount = manualDisc;
        product.discount_percentage = manualDisc;
        product.size_id = item.size_id;
        product.color_id = item.color_id;
        product.selected_price = item.price;
        product.original_price = item.price; // Added to ensure the dropdown retains the saved price
        product.default_price_value = product.sale_price;
        products_element.push(product);
      }
    })

    await this.setState({
      form: {
        ...this.state.form,
        id: element.id,
        quote_id: element.id,
        client_id: element.client_id,
        seller_id: element.seller_id || this.props.user.id,
        comments: element.comments,
        discount_percentage: element.discounts?.find(d => d.general_discount_id === null)?.porcentage || element.discount_percentage || 0,
        expiration_date: moment(element.expiration_date).isValid() ? moment(element.expiration_date).toDate() : '',
        show_taxes: element.show_taxes,
        iva: element.iva,
        credit_days: element?.credit_days,
        status_payment: element?.status_payment,
        general_discounts: (element.discounts || [])
          .filter(d => d.general_discount_id !== null)
          .map(d => ({
            discount_id: d.general_discount_id,
            value: d.porcentage,
          }))
      },
      products: products_element,
      edit: true,
      textButton: "Editar",
    });

    this.setTotals();
  };

  handleChange = async (emitter) => {
    const { name, value } = emitter.target;

    await this.setState({
      form: {
        ...this.state.form,
        [name]: value
      }
    });

    const watching = ['show_taxes', 'discount_percentage'];
    if (watching.includes(name)) {
      this.setTotals();
    }
  };

  checkedChange = async (newValue) => {
    await this.setState(prevState => ({
      form: {
        ...prevState.form,
        show_taxes: newValue == true ? Constants.QUOTES.SHOW_TAXES.YES : Constants.QUOTES.SHOW_TAXES.NO
      }
    }));
    this.setTotals();
  }

  delete = (index) => {
    Globals.confirm('¿Desea eliminar el producto de la cotización?', async () => {
      let products = [...this.state.products];
      products.splice(index, 1);
      await this.setState({ products });
      this.setTotals();
    });
  }

  changeManual = async (index, quantity) => {
    let products = [...this.state.products];
    let product = products[index];

    // Validar según el valor de decimal_stock
    if (product.decimal_stock == Constants.DECIMAL_STOCK.NO) {
      // Restringir a enteros si decimal_stock no permite decimales
      quantity = quantity.replace(/\D/g, ''); // Eliminar cualquier carácter no numérico
    } else if (product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
      // Permitir decimales con una sola coma
      quantity = quantity.replace(/[^0-9,]/g, ''); // Eliminar caracteres no numéricos excepto la coma
      const parts = quantity.split(',');
      if (parts.length > 2) {
        return; // Evitar múltiples comas decimales
      }
    }

    // Actualizar el producto con el valor procesado
    product.quantity = quantity;

    // Actualizar el estado
    await this.setState({ products });
    this.setTotals();
  };

  changeValue = async (value, target, index, callback = () => { }) => {
    let products = this.state.products;
    products[index][target] = value;
    if (target === 'original_price') products[index]._user_changed_price = true;

    await this.setState({
      products
    }, () => callback());
    this.setTotals();
  }

  addOne = async (index) => {
    let products = [...this.state.products];
    let product = products[index];

    const qty = product?.decimal_stock == Constants.DECIMAL_STOCK.YES
      ? parseFloat(String(product.quantity).replace(',', '.'))
      : parseInt(product.quantity, 10);

    product.quantity = qty + 1;
    await this.setState({ products });
    this.setTotals();
  }

  removeOne = async (index) => {
    let products = [...this.state.products];
    if (products[index].quantity > 1) {
      let product = products[index];

      const qty = product?.decimal_stock == Constants.DECIMAL_STOCK.YES
        ? parseFloat(String(product.quantity).replace(',', '.'))
        : parseInt(product.quantity, 10);

      // Restar 1 y redondear si es necesario
      product.quantity = product?.decimal_stock == Constants.DECIMAL_STOCK.YES
        ? parseFloat((qty - 1).toFixed(2)) // Limitar a 2 decimales
        : qty - 1;

      await this.setState({ products });
      this.setTotals();
    }
  };

  choseProducts = async (products = []) => {
    const { products: oldProducts } = this.state;
    const isSizeColor = (type) => Number(type) === Constants.PRODUCTS_TYPE.SIZE_COLOR;

    const nonAdded = products
      .filter(np => !oldProducts.some(op => op.id === np.id))
      .map(p => ({ ...p, quantity: 1, selected_price: isSizeColor(p.type) ? '' : p.sale_price }));

    await this.setState({
      products: [...oldProducts, ...nonAdded],
    });
    this.setTotals();
  }

  enableSubmit = () => {
    return this.setState({
      disabled_button: false
    });
  }

  submit = async () => {
    if (!this.state.products.length) {
      Globals.showWarning("Por favor, seleccione al menos un producto");
      this.enableSubmit();
      return false;
    }

    if (this.state.products.filter(i => {
      const product = this.state.products.find(_i => _i.id == i.id);
      return product.type == Constants.PRODUCTS_TYPE.SIZE_COLOR && !i.size_id && !i.color_id;
    }).length > 0) {
      Globals.showWarning("Por favor, ingrese el color/talla de los productos que lo requieran");
      this.enableSubmit();
      return false;
    }

    for (let index = 0; index < this.state.products.length; index++) {
      const i = this.state.products[index];
      const product = this.state.products.find(_i => _i.id == i.id);
      if (product.type == Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const item_find = this.state.products.find((item, _index) => {
          if (index != _index) {
            if (item.id == i.id && item.color_id == i.color_id && item.size_id == i.size_id) {
              return true;
            }
          }

          return false;
        });

        if (item_find) {
          const color = this.props.colors.find(_i => _i.id == i.color_id);
          const size = this.props.sizes.find(_i => _i.id == i.size_id);
          const product = this.state.products.find(_i => _i.id == i.id);
          Globals.showWarning(`Lo sentimos, el producto ${product?.name} (${[size?.name, color?.name].filter(i => i != null).join(',')}) se encuentra más de una vez en la cotización`);
          this.enableSubmit();
          return false;
        }
      }
    }

    for (let i = 0; i < this.state.products.length; i++) {
      const item = this.state.products[i];
      const product = this.state.products.find(_i => _i.id == item.id);
      if (product.type == Constants.PRODUCTS_TYPE.SIZE_COLOR) {
        const size_color = product?.size_colors?.find((i) => {
          if (item.size_id && item.color_id) {
            return i.size_id == item.size_id && i.color_id == item.color_id;
          }
          else if (item.size_id) {
            return i.size_id == item.size_id && i.color_id == null;
          }
          else if (item.color_id) {
            return i.color_id == item.color_id && i.size_id == null;
          }
        });
        if (!size_color) {
          const color = this.props.colors.find(_i => _i.id == item.color_id);
          const size = this.props.sizes.find(_i => _i.id == item.size_id);
          Globals.showWarning(`Lo sentimos, el producto ${product?.name} (${[size?.name, color?.name].filter(i => i != null).join(',')}) no se encuentra en inventario`);
          this.enableSubmit();
          return false;
        }
      }
    }

    if (this.state.products.filter(i => !i.quantity || i.quantity == 0).length > 0) {
      Globals.showWarning("Debe seleccionar la cantidad de todos los productos");
      this.enableSubmit();
      return false;
    }

    if (!this.state.form.client_id) {
      Globals.showWarning("El campo Cliente es requerido");
      this.enableSubmit();
      return false;
    }

    if (!this.state.form.expiration_date) {
      Globals.showWarning("El campo Fecha de Vencimiento es requerido");
      this.enableSubmit();
      return false;
    }

    if (this.state.form.discount_percentage !== '' && this.state.form.discount_percentage < 0) {
      Globals.showWarning('El porcentaje de descuento general no puede ser negativo');
      this.enableSubmit();
      return false;
    }

    if (this.state.form.discount_percentage !== '' && this.state.form.discount_percentage > 100) {
      Globals.showWarning('El porcentaje de descuento general no puede ser mayor a 100%');
      this.enableSubmit();
      return false;
    }

    const details = this.state.products.map(x => ({
      ...x,
      discount_percentage: x.discount_percentage || 0,
      discount: x.discount || 0,
      // Enviar explícitamente los campos que el backend usa para calcular descuentos por item
      manual_discount: x.manual_discount || 0,
      applied_discounts: x.applied_discounts || [],
    }));

    // Validación de porcentage de descuento de cada producto
    let error_porcentage_product = false
    details.forEach(product => {
      let manualDesc = parseFloat(product.manual_discount || 0);
      if (manualDesc < 0) {
        Globals.showWarning(`El descuento porcentual del producto ${product.name} no puede ser negativo.`);
        error_porcentage_product = true
        return
      }

      if (manualDesc > 100) {
        Globals.showWarning(`El descuento porcentual del producto ${product.name} no puede ser mayor a 100%.`);
        error_porcentage_product = true
        return
      }
    });
    if (error_porcentage_product == true) {
      this.enableSubmit();
      return false;
    }

    Globals.setLoading();

    try {
      await axios.post(this.state.edit ? 'admin/quotes/edit' : 'admin/quotes/create', {
        ...this.state.form,
        details: JSON.stringify(details),
        currency: this.props.currency,
        admin_id: this.props.user.admin_id || this.props.user.id,
        user_id: this.props.user.id,
        expiration_date: this.state.form.expiration_date && moment(this.state.form.expiration_date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        discount_percentage: this.state.form.discount_percentage || 0,
      });
      this.state.edit ? Globals.showSuccess("Se ha editado su cotización correctamente") : Globals.showSuccess("Se ha realizado su cotización correctamente");
      this.props.onClose();

    } catch (error) {
      Globals.showError("Ocurrió un error inesperado");
      this.enableSubmit();

    } finally {
      Globals.quitLoading();
    }
  }

  close = async () => {
    document.getElementsByClassName('modal').item(0).style.zIndex = 1050;
    await this.setState({ modalProducts: false });
  }

  setTotals = async () => {
    const { exchangeRate, form, products, discountsRules } = this.state;
    const decimals = this.getDecimals();
    const parse = this.parse;
    const IVA = Globals.getAdminIva();

    const isOdooUser = this.props.user && ((this.props.user.admin ? this.props.user.admin.odoo : this.props.user.odoo) == 1);
    const checkIsBultoCajaCestaUnidad = (prod) => Globals.checkIsBultoCajaCestaUnidad(prod, isOdooUser);
    // Volumen: solo bultos/cajas/cestas (excluye "Unidad")
    const checkIsBultoCajaCesta = (prod) => Globals.checkIsBultoCajaCesta(prod, isOdooUser);

    let subtotal_usd = 0;
    let original_subtotal_usd = 0;
    let totalDiscountAmount = 0;

    let new_general_discounts = [];

    if (discountsRules && discountsRules.length > 0) {
      discountsRules.forEach(master => {
        if (master.status !== 1) return;

        // A. Descuento General
        if (master.type === 'general') {
          const userDiscount = form.general_discounts.find(d => d.discount_id === master.id);
          if (userDiscount && userDiscount.value !== '') {
            new_general_discounts.push({
              discount_id: master.id,
              value: userDiscount.value
            });
          }
        }

        // B. Pronto Pago — solo aplica si el pago es a crédito
        if (master.type === 'pronto_pago' && form.status_payment === Constants.PAYMENT_TYPES.TO_PAY && form.client_id && form.credit_days) {
          const days = parseInt(form.credit_days);
          const clientId = form.client_id;
          if (!isNaN(days) && days > 0 && clientId) {
            master.discount_details.forEach(rule => {
              // Usar == (comparación flexible) para evitar problemas de tipo string vs number
              if (rule.client_id == clientId && days <= rule.max_days) {
                new_general_discounts.push({ discount_id: master.id, value: parseFloat(rule.percentage) });
              }
            });
          }
        }
      });
    }

    const cartProductIds = products.map(item => item.product_id || item.id);

    let iva_usd = 0;
    let iva_bs = 0;

    for (const product of products) {
      const qty = product?.decimal_stock == Constants.DECIMAL_STOCK.YES ? parseFloat(String(product.quantity).replace(',', '.')) : parseInt(product.quantity, 10);
      let originalPrice = parseFloat(product.original_price || product.sale_price || product.price);

      let appliedPrice = originalPrice;
      let itemPercentageDiscount = 0;
      let applied_rules = [];

      let defaultPriceToCompare = product.default_price_value ?? product.sale_price;
      if (product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR && product.size_colors) {
        const size_color = product.size_colors.find(i =>
          (product.size_id && product.color_id && i.size_id === product.size_id && i.color_id === product.color_id) ||
          (product.size_id && !product.color_id && i.size_id === product.size_id && !i.color_id) ||
          (product.color_id && !product.size_id && i.color_id === product.color_id && !i.size_id)
        );
        if (size_color && size_color.sale_price != null) {
          defaultPriceToCompare = size_color.sale_price;
        }
      }
      product.special_price_applied = false;
      product.special_price_limit = null;
      const limitMaster = (discountsRules || []).find(m => m.status === 1 && m.type === 'limite_cantidad' && m.discount_details?.some(r => r.product_id === (product.product_id || product.id)));
      const limitRule = limitMaster?.discount_details?.find(r => r.product_id === (product.product_id || product.id));
      if (limitRule && defaultPriceToCompare != null && !product._user_changed_price && parseFloat(originalPrice) === parseFloat(limitRule.special_price)) {
        originalPrice = parseFloat(defaultPriceToCompare);
        appliedPrice = originalPrice;
      }
      const isDefaultPrice = defaultPriceToCompare == null || parseFloat(originalPrice) === parseFloat(defaultPriceToCompare);

      if (discountsRules && discountsRules.length > 0 && isDefaultPrice) {
        let allApplicableVolumenRules = [];
        discountsRules.forEach(master => {
          if (master.status !== 1) return;

          let rutaVendedorApplied = false;

          master.discount_details.forEach(rule => {

            if (master.type === 'limite_cantidad' && rule.product_id === (product.product_id || product.id)) {
              if (qty <= rule.max_quantity) {
                appliedPrice = parseFloat(rule.special_price);
                product.special_price_applied = true;
                product.special_price = appliedPrice;
                product.original_special_price = appliedPrice;
                product.original_price = originalPrice;
              } else if (rule.max_quantity && qty > rule.max_quantity) {
                const specialQty = parseFloat(rule.max_quantity);
                const regularQty = qty - specialQty;
                appliedPrice = ((specialQty * parseFloat(rule.special_price)) + (regularQty * originalPrice)) / qty;
                product.special_price_applied = true;
                product.special_price = parse(appliedPrice);
                product.original_special_price = parseFloat(rule.special_price);
                product.original_price = originalPrice;
                product.special_price_limit = specialQty;
              }
            }

            if (master.type === 'volumen') {
              if ((rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === product.category_id)) && qty >= rule.min_quantity) {
                allApplicableVolumenRules.push({ rule, master });
              }
            }

            if (master.type === 'ruta_vendedor' && rule.product_id === (product.product_id || product.id) && !rutaVendedorApplied) {
              const currentSellerId = form.seller_id || (this.props.user ? this.props.user.id : null);
              const activeSeller = this.state.data.sellers?.find(s => s.id == currentSellerId) || this.props.user;
              const sellerId = activeSeller ? activeSeller.id : null;
              let isInZone = false;
              if (rule.zone_id && activeSeller) {
                if (activeSeller.zones && activeSeller.zones.length > 0) {
                  isInZone = activeSeller.zones.some(z => z.id == rule.zone_id || z.zone_id == rule.zone_id);
                } else if (activeSeller.zone_id == rule.zone_id) {
                  isInZone = true;
                }
              }

              if (isInZone || (rule.seller_id && rule.seller_id == sellerId)) {
                itemPercentageDiscount += parseFloat(rule.percentage);
                applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
                rutaVendedorApplied = true;
              }
            }

            if (master.type === 'surtido' && rule.product_id === (product.product_id || product.id)) {
              let distinctCount = 0;
              master.discount_details.forEach(surtidoRule => {
                if (surtidoRule.counts_for_calculation && cartProductIds.includes(surtidoRule.product_id)) distinctCount++;
              });

              if (distinctCount >= rule.min_quantity) {
                itemPercentageDiscount += parseFloat(rule.percentage);
                applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
              }
            }
            if (master.type === 'surtido_volumen' && (rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === (product.category_id || product.category?.id)))) {
              const isProductBulto = checkIsBultoCajaCestaUnidad(product);
              if (isProductBulto) {
                let participatingCartProdIds = [];
                let totalBultos = 0;

                products.forEach(cartProd => {
                  const isCartProdBulto = checkIsBultoCajaCestaUnidad(cartProd);
                  const isParticipating = master.discount_details.some(svRule =>
                    (svRule.product_id === (cartProd.product_id || cartProd.id) || (svRule.category_id && svRule.category_id === (cartProd.category_id || cartProd.category?.id)))
                    && svRule.counts_for_calculation
                  );
                  if (isParticipating && isCartProdBulto) {
                    // Surtido (SKU distintos): incluye "Unidad"
                    const actualCartProdId = cartProd.product_id || cartProd.id;
                    if (!participatingCartProdIds.includes(actualCartProdId)) {
                      participatingCartProdIds.push(actualCartProdId);
                    }
                  }
                  if (isParticipating && checkIsBultoCajaCesta(cartProd)) {
                    // Volumen (total bultos/cajas/cestas): NO incluye "Unidad"
                    const qtyProd = cartProd.decimal_stock == 1 || cartProd.decimal_stock == '1' || cartProd.decimal_stock == true ? parseFloat(cartProd.quantity) : parseInt(cartProd.quantity);
                    totalBultos += qtyProd;
                  }
                });

                let distinctCount = participatingCartProdIds.length;
                const meetsSku = distinctCount >= rule.min_sku;
                const meetsBultos = totalBultos >= rule.min_bultos;

                if (meetsSku && meetsBultos) {
                  const pctOne = parseFloat(rule.percentage_one_condition);
                  const pctBoth = parseFloat(rule.percentage_both_conditions);
                  if (meetsSku !== meetsBultos)
                  if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
                    itemPercentageDiscount += pctOne;
                    applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
                  }
                  if (!isNaN(pctBoth) && pctBoth > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
                    itemPercentageDiscount += pctBoth;
                    applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctBoth });
                  }
                } else if (meetsSku || meetsBultos) {
                  const pctOne = parseFloat(rule.percentage_one_condition);
                  if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
                    itemPercentageDiscount += pctOne;
                    applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
                  }
                }
              }
            }

          });
        });

        if (allApplicableVolumenRules.length > 0) {
          const categoryRules = allApplicableVolumenRules.filter(item => item.rule.category_id && item.rule.category_id === product.category_id);
          const rulesToApply = categoryRules.length > 0 ? categoryRules : allApplicableVolumenRules;

          rulesToApply.forEach(item => {
            itemPercentageDiscount += parseFloat(item.rule.percentage);
            applied_rules.push({ discount_id: item.master.id, name: item.master.name, percentage: parseFloat(item.rule.percentage) });
          });
        }
      }

      if (itemPercentageDiscount > 100) itemPercentageDiscount = 100;

      // Asegurarnos de tener el manual_discount guardado la primera vez.
      if (product.manual_discount === undefined) {
        product.manual_discount = Number(product.discount_percentage || product.discount || 0);
      }

      let finalUnitPrice = appliedPrice;

      if (product.manual_discount > 0) {
        let manualDesc = parseFloat(product.manual_discount);
        if (manualDesc > 100) manualDesc = 100;
        finalUnitPrice -= (finalUnitPrice * (manualDesc / 100));
      }

      if (applied_rules.length > 0) {
        applied_rules.forEach(ar => {
          let ruleDesc = parseFloat(ar.percentage);
          if (!isNaN(ruleDesc) && ruleDesc > 0) {
            if (ruleDesc > 100) ruleDesc = 100;
            finalUnitPrice -= (finalUnitPrice * (ruleDesc / 100));
          }
        });
      }

      if (finalUnitPrice < 0) finalUnitPrice = 0;

      product.selected_price = appliedPrice;

      const autoDiscountStr = applied_rules.map(r => `${r.percentage}%`).join(' / ');
      if (product.manual_discount > 0 && applied_rules.length > 0) {
        product.discount = `${product.manual_discount}% / ${autoDiscountStr}`;
      } else if (product.manual_discount > 0) {
        if (parseFloat(String(product.discount).replace(/,/g, '.')) !== product.manual_discount) {
          product.discount = product.manual_discount;
        }
      } else if (applied_rules.length > 1) {
        product.discount = autoDiscountStr;
      } else if (applied_rules.length === 1) {
        product.discount = applied_rules[0].percentage;
      } else {
        if (parseFloat(String(product.discount).replace(/,/g, '.')) !== 0) {
          product.discount = '';
        }
      }

      product.applied_discounts = applied_rules;

      const lineOriginalSubtotal = qty * originalPrice;
      const lineFinalSubtotal = qty * finalUnitPrice;

      product.subtotal = parse(lineFinalSubtotal);
      original_subtotal_usd += parse(lineOriginalSubtotal);
      subtotal_usd += product.subtotal;

      if (form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES && product.exento == Constants.PRODUCT_EXENTO.NO) {
        iva_usd += product.subtotal;
        iva_bs += (product.subtotal * exchangeRate);
      }
    }

    let currentSubtotal = subtotal_usd;

    if (form.discount_percentage > 0) {
      let desc = parseFloat(form.discount_percentage);
      if (desc > 100) desc = 100;
      currentSubtotal -= (currentSubtotal * (desc / 100));
    }

    new_general_discounts.forEach(gd => {
      let desc = parseFloat(gd.value);
      if (desc > 100) desc = 100;
      currentSubtotal -= (currentSubtotal * (desc / 100));
    });

    if (currentSubtotal < 0) currentSubtotal = 0;

    totalDiscountAmount = subtotal_usd - currentSubtotal;
    const totalDiscountPercentage = totalDiscountAmount > 0 ? (totalDiscountAmount / subtotal_usd) * 100 : 0;

    // Construir appliedDiscountsRules agrupando los descuentos por producto (igual que la app)
    const appliedDiscountsRulesMap = {};

    let final_iva_usd = 0;
    let final_iva_bs = 0;

    if (form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES) {
      if (totalDiscountPercentage > 0) {
        const discountOnIvaUsd = iva_usd * (totalDiscountPercentage / 100);
        iva_usd -= discountOnIvaUsd;
        iva_bs -= (discountOnIvaUsd * exchangeRate);
      }
      final_iva_usd = parse((iva_usd * IVA) / 100);
      final_iva_bs = parse((iva_bs * IVA) / 100);
      currentSubtotal += final_iva_usd;

      // Asignar el IVA correspondiente a cada producto para la vista
      products.forEach(p => {
        if (p.exento == Constants.PRODUCT_EXENTO.NO) {
          const discountedSubtotal = p.subtotal * (1 - (totalDiscountPercentage / 100));
          p.iva = parse((discountedSubtotal * IVA) / 100);
        } else {
          p.iva = 0;
        }
      });
    } else {
      products.forEach(p => p.iva = 0);
    }

    products.forEach(item => {
      if (!item.applied_discounts || item.applied_discounts.length === 0) return;
      const qty = item?.decimal_stock == Constants.DECIMAL_STOCK.YES ? parseFloat(String(item.quantity).replace(',', '.')) : parseInt(item.quantity, 10);
      const origPrice = parseFloat(item.selected_price || item.original_price || item.sale_price || item.price);
      let runningSubtotal = qty * origPrice;
      if (item.manual_discount > 0) {
        const manualDesc = parseFloat(item.manual_discount) > 100 ? 100 : parseFloat(item.manual_discount);
        runningSubtotal -= runningSubtotal * (manualDesc / 100);
      }

      item.applied_discounts.forEach(ad => {
        const mapKey = `${ad.discount_id}_${ad.percentage}`;
        if (!appliedDiscountsRulesMap[mapKey]) {
          appliedDiscountsRulesMap[mapKey] = {
            id: ad.discount_id,
            name: ad.name,
            percentage: parseFloat(ad.percentage),
            totalAmount: 0,
          };
        }
        const pct = parseFloat(ad.percentage) > 100 ? 100 : parseFloat(ad.percentage);
        const ruleAmount = runningSubtotal * (pct / 100);
        runningSubtotal -= ruleAmount;
        appliedDiscountsRulesMap[mapKey].totalAmount = parse(
          appliedDiscountsRulesMap[mapKey].totalAmount + parse(ruleAmount)
        );
      });
    });

    // Construir appliedDiscountsGeneral (descuentos globales) igual que la app
    const appliedDiscountsGeneral = [];
    const allGlobalDiscounts = [];
    if (form.discount_percentage > 0) {
      allGlobalDiscounts.push({ discount_id: null, value: parseFloat(form.discount_percentage) });
    }
    new_general_discounts.forEach(gd => {
      allGlobalDiscounts.push(gd);
    });

    allGlobalDiscounts.forEach(gd => {
      const masterInfo = discountsRules?.find(r => r.id === gd.discount_id);
      appliedDiscountsGeneral.push({
        id: gd.discount_id,
        name: gd.discount_id == null ? 'Descuento' : masterInfo?.name || 'Descuento General',
        percentage: parseFloat(gd.value),
        totalAmount: 0,
      });
    });

    if (appliedDiscountsGeneral.length > 0) {
      let cascadeSubtotal = subtotal_usd;
      appliedDiscountsGeneral.forEach(gd => {
        let desc = parseFloat(gd.percentage);
        if (desc > 100) desc = 100;
        const discountAmount = cascadeSubtotal * (desc / 100);
        gd.totalAmount = parse(discountAmount);
        cascadeSubtotal -= discountAmount;
      });
    }

    const appliedDiscountsRules = Object.values(appliedDiscountsRulesMap).concat(appliedDiscountsGeneral);

    await this.setState({
      products,
      appliedDiscountsRules,
      original_subtotal_usd: parse(original_subtotal_usd),
      form: {
        ...this.state.form,
        subtotal: parse(subtotal_usd),
        discount: parse(totalDiscountAmount),
        iva: final_iva_usd,
        iva_bs: final_iva_bs,
        total: parse(currentSubtotal),
        general_discounts: new_general_discounts
      },
    })
  }

  getPrices = (product) => {
    let size_color = null;
    let prices = product.prices;
    const decimals = this.getDecimals(); // Decimales dinámicos

    if (product?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      size_color = product?.size_colors?.find((i) => {
        if (product.size_id && product.color_id) {
          return i.size_id === product.size_id && i.color_id === product.color_id;
        }
        else if (product.size_id) {
          return i.size_id === product.size_id && !i.color_id;
        }
        else if (product.color_id) {
          return i.color_id === product.color_id && !i.size_id;
        }

        return null;
      });

      prices = size_color?.prices || [];
      product.price = (product?.size_colors.length > 0 ? product?.size_colors[0].sale_price : 0);

    } else {
      product.price = product.sale_price;
    }

    const defaultPrice = parseFloat(size_color?.sale_price || product.price);
    const rawPrices = [];
    if (!isNaN(defaultPrice)) rawPrices.push(defaultPrice);

    if (product.original_price !== undefined && product.original_price !== null) {
      const parsedOriginal = parseFloat(product.original_price);
      if (!isNaN(parsedOriginal)) rawPrices.push(parsedOriginal);
    }

    // Para conservar el unit_description si existe, en lugar de usar un Set simple de números
    // usaremos un mapa para asegurarnos de que cada número aparezca solo una vez.
    const uniquePricesMap = new Map();

    if (!isNaN(defaultPrice)) {
      uniquePricesMap.set(defaultPrice, `$${Globals.formatMiles(defaultPrice, decimals)}`);
    }

    if (product.original_price !== undefined && product.original_price !== null) {
      const parsedOriginal = parseFloat(product.original_price);
      if (!isNaN(parsedOriginal) && !uniquePricesMap.has(parsedOriginal)) {
        uniquePricesMap.set(parsedOriginal, `$${Globals.formatMiles(parsedOriginal, decimals)}`);
      }
    }

    prices.forEach(i => {
      const p = parseFloat(i.price);
      if (!isNaN(p) && !uniquePricesMap.has(p)) {
        uniquePricesMap.set(p, `$${Globals.formatMiles(p, decimals)} ${i.hasOwnProperty('unit_description') && i.unit_description ? ` ${i.unit_description}` : ''}`);
      }
    });

    return Array.from(uniquePricesMap.entries()).map(([val, label]) => ({
      value: val,
      label: label
    }));
  }

  change = async (value, target) => {
    await this.setState(state => ({ form: { ...state.form, [target]: value } }));

    // Recalcular totales cuando cambian campos que afectan descuentos automáticos
    const triggerRecalc = ['client_id', 'credit_days', 'status_payment', 'seller_id'];
    if (triggerRecalc.includes(target)) {
      this.setTotals();
    }
  }

  debouncingSearchClient = async (search) => {
    if (this.debounce.current) clearTimeout(this.debounce.current);

    await this.change(undefined, 'client_id');
    await this.change(search, 'search');
    this.debounce.current = setTimeout(async () => {
      this.getClients();
    }, 1000);
  }

  toggleClientModal = () => {
    this.setState(state => ({ visible_client: !state.visible_client }));
  }

  setPaymentType = (status_payment) => {
    this.setState({
      form: {
        ...this.state.form,
        status_payment,
        // Al pasar a Contado, limpiar los días de crédito para que no apliquen descuentos de pronto_pago
        credit_days: status_payment === Constants.PAYMENT_TYPES.PAID ? null : this.state.form.credit_days,
      }
    }, () => this.setTotals());
  }

  render() {
    const { submitted, products, data, disabled_button, visible_client, } = this.state;
    const can_include_taxes = Globals.canIncludeTaxes(this.props.user)
    const filtered_clientCategories = data.client_categories.filter(Item => {
      return Item.id && Item.id > 0;
    });

    // Obtener cantidad de decimales para renderizado
    const decimals = this.getDecimals();

    const appliedAutomaticDiscounts = [];

    products.forEach(item => {
      if (item.applied_discounts && item.applied_discounts.length > 0) {
        item.applied_discounts.forEach(ad => {
          const existing = appliedAutomaticDiscounts.find(d => d.name === ad.name && d.percentage === ad.percentage);
          if (!existing) {
            appliedAutomaticDiscounts.push({
              name: ad.name,
              percentage: ad.percentage,
              icon: 'fa-cube'
            });
          }
        });
      }
      if (item.special_price_applied) {
        const existing = appliedAutomaticDiscounts.find(d => d.name === 'Precio Especial');
        if (!existing) {
          appliedAutomaticDiscounts.push({
            name: 'Precio Especial',
            percentage: 'Especial',
            icon: 'fa-tag'
          });
        }
      }
    });

    if (this.state.form.general_discounts && this.state.form.general_discounts.length > 0) {
      this.state.form.general_discounts.forEach(gd => {
        const ruleInfo = this.state.discountsRules?.find(r => r.id === gd.discount_id);
        if (ruleInfo && ruleInfo.type !== 'general') {
          appliedAutomaticDiscounts.push({
            name: ruleInfo.name,
            percentage: gd.value,
            icon: 'fa-clock-o'
          });
        }
      });
    }

    return (
      <form onSubmit={this.submit}>
        <div className="container-create-edit-quote">
          <Modal
            title="Seleccionar producto"
            onClose={() => this.close()}
            visible={this.state.modalProducts}
          >
            <SelectProduct
              onSelect={this.choseProducts}
              onClose={() => this.close()}
            />
          </Modal>

          <Modal
            size="lg"
            className="modal-report-sale-client"
            title="Registrar cliente"
            onClose={this.toggleClientModal}
            visible={visible_client}
          >
            <CreateEditClient
              user={this.props.user}
              createFromPOS={true}
              zones={data.zones}
              onSuccess={client => this.setState({ created_client: client })}
              onClose={(reload = false) => {
                if (reload) this.getClients();
                this.toggleClientModal();
              }}
              client_categories={filtered_clientCategories}
              sellers={data.sellers}
            />
          </Modal>

          {this.state.modalProducts && (
            <div
              className="backdrop"
              onClick={() => this.close()}
            />
          )}

          <div className="d-flex justify-content-end">
            <button
              className="add"
              type="button"
              title="Agregar producto"
              onClick={() => {
                document.getElementsByClassName('modal').item(0).style.zIndex = 1040;
                this.setState({ modalProducts: true })
              }}
            >
              <img src={AddIcon} alt="Agregar producto" />
            </button>
          </div>

          {products.length === 0 && (
            <div className="no-items">No hay productos en la cotización</div>
          )}

          {products.map((product, index) => {
            const isSizeColor = Number(product?.type) === Constants.PRODUCTS_TYPE.SIZE_COLOR;

            let priceJSX = product.special_price_applied ? (
              <span className="text-success font-weight-bold" title="Precio especial aplicado" style={{ cursor: 'help', borderBottom: '1px dotted #28a745' }}>
                {Globals.newFormatMiles(product.selected_price, decimals)}
              </span>
            ) : (
              <span>{Globals.newFormatMiles(product.selected_price, decimals)}</span>
            );

            let discountJSX = null;
            if (product.discount != null && product.discount !== '' && product.discount !== 0) {
              let discount_str = String(product.discount).replace(/%$/, '');
              let names = [];
              if (product.manual_discount > 0) names.push('Manual');
              if (product.applied_discounts && product.applied_discounts.length > 0) {
                names = names.concat(product.applied_discounts.map(d => d.name));
              }
              discountJSX = (
                <span>
                  {' - '}{discount_str}%
                  {names.length > 0 ? ` (${names.join(' + ')})` : ''}
                </span>
              );
            }

            let taxJSX = null;
            if (this.state.form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES && product.exento == Constants.PRODUCT_EXENTO.NO) {
              taxJSX = <span>{' + '}{Globals.newFormatMiles(product.iva, decimals)} {this.state.countryEquivalent.ivaAbbreviation}</span>;
            }

            let label_total = (
              <React.Fragment>
                ({product.quantity} x {priceJSX})
                {discountJSX}
                {taxJSX}
              </React.Fragment>
            );

            return (
              <div key={`product-${index}`} className="product-item">
                <div className="product-image">
                  <img src={Globals.fromPhotos(product?.photo?.file)} alt="Foto del producto" />
                </div>

                <div className="product-details">
                  <div className="product-name" title={product.name}>{product.name}</div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', marginTop: '0.5rem' }}>
                    <Select
                      color="gray"
                      label="Precio"
                      defaultname="Seleccione"
                      className="material flex-1"
                      labelClass="material"
                      disabledFirst={false}
                      onChange={e => {
                        if (Globals.validateDouble(e.target.value) || e.target.value === '') {
                          this.changeValue(e.target.value, 'original_price', index);
                        }
                      }}
                      value={parseFloat(product.original_price || product.sale_price || product.price)}
                      options={this.getPrices(product)}
                    />

                    <div className="form-group flex-1">
                      <label className="material">Descuento (%)</label>
                      <input
                        type="text"
                        value={product.manual_discount !== undefined ? product.manual_discount : (product.discount_percentage || '')}
                        className="form-control material"
                        placeholder="Opcional"
                        onChange={e => {
                          let val = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
                          if ((val.match(/\./g) || []).length > 1) {
                            val = val.substring(0, val.length - 1);
                          }
                          this.changeValue(val, 'manual_discount', index);
                        }}
                      />
                    </div>
                  </div>

                  <div className="product-price">
                    <span>
                      $ {Globals.formatMiles(
                        (this.state.form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES && product.exento == Constants.PRODUCT_EXENTO.NO
                          ? parseFloat(product.subtotal) + parseFloat(product.iva || 0)
                          : parseFloat(product.subtotal)
                        ).toFixed(decimals)
                      )}
                      {' '}
                      {label_total}
                    </span>
                  </div>

                  <div className="product-qty-section">
                    <div className="product-qty-button" onClick={() => this.removeOne(index)}>
                      <span>-</span>
                    </div>
                    <input
                      className="product-qty"
                      value={product.quantity}
                      onChange={e => this.changeManual(index, e.target.value)}
                    />
                    <div className="product-qty-button" onClick={() => this.addOne(index)}>
                      <span>+</span>
                    </div>
                  </div>

                  {
                    isSizeColor && (
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        {
                          [...new Set(product?.size_colors?.filter((i) => i.color_id).map(i => i.color_id))].length > 0 && (
                            <div style={{ flex: 1 }}>
                              <div>Color:</div>
                              <div className="colors">
                                {
                                  [...new Set(product?.size_colors?.filter((i) => i.color_id).map(i => i.color_id))].map((_item) => {
                                    return (
                                      <div
                                        className={`color ${product.color_id == _item ? 'selected' : ''}`}
                                        style={{ backgroundColor: product?.size_colors?.find(x => x.color_id === _item)?.color?.hex }}
                                        onClick={() => {
                                          this.changeValue(Number(_item), 'color_id', index, () => {
                                            const size_color = product?.size_colors?.find((i) => {
                                              if (product.size_id && product.color_id) {
                                                return i.size_id == product.size_id && i.color_id == product.color_id;
                                              }
                                              else if (product.size_id) {
                                                return i.size_id == product.size_id && i.color_id == null;
                                              }
                                              else if (product.color_id) {
                                                return i.color_id == product.color_id && i.size_id == null;
                                              }
                                            });
                                            if (size_color)
                                              this.changeValue(size_color?.sale_price, 'price', index, () => {
                                                this.changeValue(size_color?.sale_price, 'selected_price', index, () => {
                                                  const prods = [...this.state.products];
                                                  prods[index].original_price = size_color?.sale_price;
                                                  prods[index]._user_changed_price = false;
                                                  this.setState({ products: prods }, () => this.setTotals());
                                                });
                                              });
                                          });
                                        }} />
                                    )
                                  })
                                }
                              </div>
                            </div>
                          )
                        }
                        {
                          [...new Set(product?.size_colors?.filter((i) => i.size_id).map(i => i.size_id))].length > 0 && (
                            <div style={{ flex: 1 }}>
                              <div>Talla:</div>
                              <Select
                                disabledFirst={false}
                                onChange={e => {
                                  this.changeValue(Number(e.target.value), 'size_id', index, () => {
                                    const size_color = product?.size_colors?.find((i) => {
                                      if (product.size_id && product.color_id) {
                                        return i.size_id == product.size_id && i.color_id == product.color_id;
                                      }
                                      else if (product.size_id) {
                                        return i.size_id == product.size_id && i.color_id == null;
                                      }
                                      else if (product.color_id) {
                                        return i.color_id == product.color_id && i.size_id == null;
                                      }
                                    });
                                    if (size_color)
                                      this.changeValue(size_color?.sale_price, 'price', index, () => {
                                        this.changeValue(size_color?.sale_price, 'selected_price', index, () => {
                                          const prods = [...this.state.products];
                                          prods[index].original_price = size_color?.sale_price;
                                          prods[index]._user_changed_price = false;
                                          this.setState({ products: prods }, () => this.setTotals());
                                        });
                                      });
                                  });
                                }}
                                options={[...new Set(product?.size_colors?.filter((i) => i.size_id).map(i => i.size_id))].map(_item => {
                                  const size = product.size_colors?.find(i => i.size_id === _item);
                                  // Calcular stock total de esa talla (sumando todas las variantes de color)
                                  const sizeVariants = product.size_colors?.filter(i => i.size_id === _item) || [];
                                  const sizeStock = sizeVariants.reduce((acc, sc) => acc + (sc.stock ?? 0), 0);
                                  const noStock = sizeStock <= 0;
                                  return {
                                    value: size?.size?.id,
                                    label: noStock ? `${size?.size?.name} (sin stock)` : size?.size?.name,
                                    disabled: noStock,
                                  }
                                })}
                                value={product.size_id}
                                className="material"
                                labelClass="material"
                                placeholder="Todos"
                              />
                            </div>
                          )
                        }
                      </div>
                    )
                  }
                </div>

                <div className="product-trash">
                  <img
                    src={TrashIcon}
                    title="Eliminar de la lista"
                    alt="Eliminar"
                    onClick={() => this.delete(index)}
                  />
                </div>
              </div>
            )
          })}

          <div className="total-price">
            <div>SUBTOTAL:</div>
            <div>$ {Globals.formatMiles(parseFloat(this.state.original_subtotal_usd || this.state.form.subtotal).toFixed(decimals))}</div>
          </div>
          {/* Descuentos por producto y globales - igual que la app */}
          {(this.state.appliedDiscountsRules || []).filter(i => i.name !== 'Precio Especial').map((item, idx) => (
            <div className="total-price" style={{ marginTop: '0.5rem' }} key={`disc-rule-${idx}`}>
              <div>{item.name.toUpperCase()}:</div>
              <div style={{ color: '#e74c3c' }}>-$ {Globals.formatMiles(item.totalAmount.toFixed(decimals))}</div>
            </div>
          ))}
          {this.state.form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES && (
            <div className="total-price" style={{ marginTop: '0.5rem' }}>
              <div>{this.state.countryEquivalent.ivaAbbreviation}:</div>
              <div>$ {Globals.formatMiles(parseFloat(this.state.form.iva).toFixed(decimals))}</div>
            </div>
          )}
          <div className="total-price" style={{ marginTop: '0.5rem' }}>
            <div>TOTAL:</div>
            <div>$ {Globals.formatMiles(parseFloat(this.state.form.total).toFixed(decimals))}</div>
          </div>

          <div className="row">
            <div className="tab-container">
              <div
                className={`tab ${this.state.form.status_payment === Constants.PAYMENT_TYPES.PAID ? 'selected' : ''}`}
                onClick={() => this.setPaymentType(Constants.PAYMENT_TYPES.PAID)}
              >
                Contado
              </div>
              <div
                className={`tab ${this.state.form.status_payment === Constants.PAYMENT_TYPES.TO_PAY ? 'selected' : ''}`}
                onClick={() => this.setPaymentType(Constants.PAYMENT_TYPES.TO_PAY)}
              >
                Crédito
              </div>
            </div>
          </div>

          <div className="row">
            <SelectActions
              label="Cliente"
              placeholder="Seleccione"
              isSearchable
              actionOptions={[
                {
                  onClick: () => this.toggleClientModal(),
                  content: (
                    <div style={{ color: '#3A7FC2' }}>
                      <span>Registrar nuevo cliente</span>
                      <i className="fa fa-regular fa-plus" style={{ marginLeft: '0.25rem' }} />
                    </div>
                  ),
                }
              ]}
              options={data.clients.map(i => ({
                value: i.id,
                label: i.name,
                actions: [],
              }))}
              value={this.state.form.client_id}
              onChange={id => this.change(id, 'client_id')}
              onInputChange={this.debouncingSearchClient}
            />

            <SelectActions
              label="Vendedor"
              placeholder="Seleccione"
              isSearchable
              options={data.sellers}
              value={this.state.form.seller_id}
              onChange={id => this.change(id, 'seller_id')}
            />
          </div>

          <div className="row">
            <DatePicker
              color="white"
              label="Fecha de Expiración"
              className="material"
              value={this.state.form.expiration_date}
              onChange={value => this.handleChange({ target: { value, name: 'expiration_date' } })}
            />

            {this.state.form.status_payment === Constants.PAYMENT_TYPES.TO_PAY && (
              <Input
                type="number"
                label="Días de Crédito"
                className="material"
                labelClass="material"
                value={this.state.form.credit_days}
                onChange={e => {
                  if (Globals.validateInteger(e.target.value) || e.target.value === '') {
                    this.change(e.target.value, 'credit_days');
                  }
                }}
              />
            )}

            <div className="form-group">
              <label className="material">Descuento (%)</label>
              <input
                type="text"
                value={this.state.form.discount_percentage}
                className="form-control material"
                placeholder="0.00"
                onChange={e => {
                  let val = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
                  if ((val.match(/\./g) || []).length > 1) {
                    val = val.substring(0, val.length - 1);
                  }
                  this.handleChange({ target: { value: val, name: 'discount_percentage' } });
                }}
              />
            </div>
          </div>

          <div className="row">
            {this.state.discountsRules && this.state.discountsRules
              .filter(master => master.type === 'general' && master.status === 1)
              .map((discount) => {
                const currentDiscount = this.state.form.general_discounts?.find(d => d.discount_id === discount.id);
                const currentValue = currentDiscount ? currentDiscount.value : '';

                return (
                  <div className="form-group" key={`general-discount-input-${discount.id}`}>
                    <label className="material" style={{ whiteSpace: 'nowrap' }}>{discount.name} %</label>
                    <input
                      id={`discount-input-${discount.id}`}
                      type="text"
                      value={currentValue}
                      className="form-control material"
                      placeholder="Opcional"
                      onChange={e => {
                        let val = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
                        if ((val.match(/\./g) || []).length > 1) {
                          val = val.substring(0, val.length - 1);
                        }
                        if (val === '' || parseFloat(val) <= 100) {
                          this.changeGeneralDiscount(discount.id, val);
                        }
                      }}
                    />
                  </div>
                );
              })
            }

          </div>

          {appliedAutomaticDiscounts.length > 0 && (
            <div className="applied-discounts-wrapper mt-3 mb-3" style={{ border: '2px solid #2874A6', borderRadius: '4px', padding: '10px', backgroundColor: '#eef2f7', width: '100%' }}>
              <label className="font-weight-bold mb-2" style={{ color: '#00204a', display: 'block', fontSize: '14px' }}>
                Descuentos añadidos
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {appliedAutomaticDiscounts.map((ad, idx) => (
                  <div key={`auto-discount-${idx}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#e2e9f3', color: '#333', padding: '4px 6px', borderRadius: '4px', fontSize: '13px', fontWeight: '600' }}>
                    <i className={`fa ${ad.icon} mr-2`} style={{ color: '#6c757d' }}></i>
                    <span style={{ marginRight: '8px' }}>{ad.name}</span>
                    {ad.percentage !== 'Especial' ? (
                      <span style={{ backgroundColor: '#2874A6', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
                        {ad.percentage}%
                      </span>
                    ) : (
                      <span style={{ backgroundColor: '#198754', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
                        {ad.percentage}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}


          <Input
            color=" "
            value={this.state.form.comments}
            name="comments"
            label="Agregar información adicional (Opcional)"
            className="material"
            labelClass="material"
            onChange={this.handleChange}
          />

          {can_include_taxes && (
            <div className="export-option" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '8rem' }}>
              <input
                name="show_taxes"
                id="exento-check"
                type="checkbox"
                checked={this.state.form.show_taxes === Constants.QUOTES.SHOW_TAXES.YES}
                style={{ marginRight: '0.5rem' }}
                onChange={() => this.checkedChange(!this.state.form.show_taxes)}
              />
              <label className="" htmlFor="exento-check" style={{ fontSize: 20, marginBottom: 0 }}>
                Incluir Impuesto
              </label>
            </div>
          )}

          {submitted ? (
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <div id="button" className="d-flex justify-content-center">
              <Button
                color=" "
                type="button"
                className="primary"
                disabled={disabled_button}
                onClick={() => this.submit()}
              >
                <span>{this.state.textButton}</span>
              </Button>
            </div>
          )}
        </div>
      </form>
    );
  }
}

const SelectProduct = ({ onSelect, onClose }) => {
  const user = useSelector(state => state.user);
  const adminId = user.level_id === Constants.ROLE_ADMIN ? user.id : user.admin_id;

  const { products, search, fetchMore, isLoading, pagination } = useFetch(adminId);
  const [selected, setSelected] = useState([]);

  const select = (item) => {
    if (selected.includes(item.id)) {
      const others = selected.filter(x => x !== item.id);
      setSelected(others);
    } else {
      setSelected([...selected, item.id]);
    }
  }

  const submit = () => {
    onSelect(products.filter(x => selected.includes(x.id)));
    onClose();
  }

  return (
    <div id="container-create-edit-quote-select-product">
      <Input
        color=" "
        placeholder="Buscar por nombre o código"
        className="material"
        labelClass="material"
        onChange={e => search(e.target.value)}
      />

      {!!selected.length && (
        <div className="product-totals">
          <span>Seleccionados: {selected.length}</span>
          <button
            type="button"
            className="done"
            title="Agregar a la cotización"
            onClick={() => submit()}
          >
            <Icon name="check" />
          </button>
        </div>
      )}

      {products.map((item, index) => {
        const isSizeColor = Number(item?.type) === Constants.PRODUCTS_TYPE.SIZE_COLOR;
        const isSelected = selected.includes(item.id);
        const stock = item?.decimal_stock == Constants.DECIMAL_STOCK.YES
          ? parseFloat(String(Number(item.stock)).replace(',', '.'))
          : parseInt(Number(item.stock), 10);

        return (
          <div
            key={`product-item-${index}`}
            className={`product-item ${isSelected ? 'selected' : ''}`}
            onClick={() => select(item)}
          >
            <div className="product-image">
              <img src={Globals.fromPhotos(item?.photo?.file)} alt="Producto" />
            </div>
            <div className="product-details">
              <span className="product-name" title={item?.code} style={{ fontWeight: 'bold', fontSize: '12px' }}>Cod. {item?.code}</span>
              <span className="product-name" title={item?.name}>{item?.name}</span>
              <span className="product-name" title={item?.code} style={{ fontSize: '12px' }}>Cantidad: {stock}</span>
            </div>
            <div>{isSizeColor ? '' : '$' + item?.sale_price}</div>
          </div>
        )
      })}

      <div className="d-flex justify-content-center mt-4">
        {isLoading && <span>Cargando...</span>}
        {(!isLoading && pagination.page < pagination.last_page) && (
          <Button onClick={() => fetchMore()}>
            <span>Cargar más</span>
          </Button>
        )}
      </div>
    </div>
  );
}

const useFetch = (admin_id) => {
  const initialForm = {
    web: true,
    admin_id,
    search: '',
    page: 1,
    per_page: 20,
    last_page: 1,
    item_count: 0,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [pagination, setPagination] = useState(initialForm);

  const debounceTime = 500;
  let debounce = null;

  const fetchData = async () => {
    if (!canFetch) return;

    const payload = {
      ...pagination,
      status: Constants.STATUS_ACTIVE,
    }

    try {
      const res = await axios.post('web/admin/quotes/products', payload);

      if (!res?.data?.products)
        return Globals.showError('Ocurrió un error inesperado');

      setCanFetch(false);
      setPagination({
        ...pagination,
        item_count: res?.data?.products?.total,
        last_page: res.data?.products.last_page,
      });

      const newData = pagination.page > 1
        ? [...data, ...res.data?.products?.data]
        : res.data?.products?.data;

      setData(newData);

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setPagination(initialForm);
    fetchData();
  }

  const fetchMore = (page = pagination.page + 1) => {
    if (page >= 1 && page <= pagination.last_page && page !== pagination.page) {
      setCanFetch(true);
      setPagination({ ...pagination, page });
    }
  }

  const search = (search) => {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(() => {
      setCanFetch(true);
      setPagination({ ...pagination, page: 1, search });
    }, debounceTime);
  }

  useEffect(() => {
    fetchData();
  }, [pagination]);

  return {
    products: data,
    pagination,
    fetchMore,
    reload,
    isLoading: canFetch,
    search,
  }
}

export default connect(state => {
  return {
    user: state.user
  };
})(CreateEditQuote);
